import { createStorage, sessionStorageMethods } from '/storage';

export const urlStorage = createStorage({ storage: sessionStorageMethods });
